// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__OZDem","content":"styles_content__2TvZE","checkbox":"styles_checkbox__1pGn4","checkboxLabel":"styles_checkboxLabel__3Vmgd"};